import { render, staticRenderFns } from "./DeleteEvents.vue?vue&type=template&id=88db6b6e"
import script from "./DeleteEvents.vue?vue&type=script&lang=ts"
export * from "./DeleteEvents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports